// import { useEffect } from 'react';
// import PropTypes from 'prop-types';
// import { useNavigate } from 'react-router-dom';

// // project imports
// import useAuth from 'hooks/useAuth';
// import config from 'config';
// import useQuery from 'hooks/useQuery';

// const GuestGuard = ({ children }) => {
// 	const { isLoggedIn } = useAuth();
// 	const navigate = useNavigate();

// 	const query = useQuery();
// 	const eid = query.get('eid');
// 	const toPage = query.get('to');

// 	useEffect(() => {
// 		if (isLoggedIn) {
// 			if (toPage) {
// 				navigate(`/${toPage}`, { replace: true });
// 			} else if (eid) {
// 				navigate(`/event/registration/${eid}`, { replace: true });
// 			} else {
// 				// navigate(config.defaultPath, { replace: true });
// 			}
// 		}
		
// 	}, [isLoggedIn, navigate, eid, toPage]);

// 	return children;
// };

// GuestGuard.propTypes = {
// 	children: PropTypes.node
// };

// export default GuestGuard;


import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

// project imports
// --- THIS IS THE FIX ---
// 1. We remove the faulty `useAuth` hook.
// import useAuth from 'hooks/useAuth';
// 2. We import the Redux selector directly.
import { useSelector } from 'react-redux';
import { selectUser } from 'store/user/userSlice';
import config from 'config';
import useQuery from 'hooks/useQuery';

const GuestGuard = ({ children }) => {
    // 3. We get the state directly from the Redux store. This is the single source of truth.
    const { isLoggedIn, isInitialized } = useSelector(selectUser);
    const navigate = useNavigate();

    const query = useQuery();
    const eid = query.get('eid');
    const toPage = query.get('to');

    useEffect(() => {
        // 4. We wait for the state to be initialized AND for the user to be logged in.
        if (isInitialized && isLoggedIn) {
            if (toPage) {
                navigate(`/${toPage}`, { replace: true });
            } else if (eid) {
                navigate(`/event/registration/${eid}`, { replace: true });
            } else {
                // 5. We uncomment the default navigation path.
                navigate(config.defaultPath, { replace: true });
            }
        }
    }, [isInitialized, isLoggedIn, navigate, eid, toPage]);

    // 6. We add a guard to render nothing until the session is checked.
    // This prevents a "flash" of the login page for an already-logged-in user.
    if (!isInitialized) {
        return null;
    }

    return children;
};

GuestGuard.propTypes = {
    children: PropTypes.node
};

export default GuestGuard;